import React from 'react';
import PropTypes from 'prop-types';
import messages from '../messages';
import { FormattedMessage } from 'react-intl';

const NameColumnId = 'NAME_COLUMN';

const NameHeader = () => {
  return (
    <div>
      <FormattedMessage {...messages.orderItemsNameColumnLabel} />
    </div>
  );
};

const NameCell = ({ cell }) => {
  const { value } = cell;

  return <>{value.name}</>;
};

NameCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export { NameHeader, NameCell, NameColumnId };
